import { render } from "./SetupView.vue?vue&type=template&id=2d0e6360&scoped=true"
import script from "./SetupView.vue?vue&type=script&lang=js"
export * from "./SetupView.vue?vue&type=script&lang=js"

import "./SetupView.vue?vue&type=style&index=0&id=2d0e6360&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0e6360"]])

export default __exports__